/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { Collapse } from "react-bootstrap";

import useToken from "../Components/useToken";
import Pagination from "../Components/Pagination";
import SearchForm from "../Components/SearchForm";
import ModalError from "../Components/ModalError";
import ModalSuccess from "../Components/ModalSuccess";
import StatusSelect from "../Components/StatusSelector";

import PrenotazioniTable, { mapStatus } from "../Components/PrenotazioniTable";
import PrenotazioneAddOffcanvas from "../Components/PrenotazioneAddOffcanvas";
import PrenotazioneUpdateOffcanvas from "../Components/PrenotazioneUpdateOffcanvas";
import PrenotazioneInfoOffcanvas from "../Components/PrenotazioneInfoOffcanvas";
import PrenotazioneAddGiornoOffcanvas from "../Components/PrenotazioneAddGiornoOffcanvas";
import ModalDeletePrenotazione from "../Components/ModalDeletePrenotazione";

import {
  getAlloggi,
  getPrenotazioniAll,
  getAlloggiByStatus,
  getAllUtenti,
  getStrutture,
  getTappeAll,
  deletecammino,
  updatecammino,
  insertcammino2,
  insertcammino,
  downloadServiziCSV
} from "../Common/utils";

const Tappe = () => {
  // State variables
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [prenotazioniAll, setPrenotazioniAll] = useState({});
  const { token } = useToken();
  const [alloggi, setAlloggi] = useState([]);
  const [status, setStatus] = useState({ value: 'all', name: 'Tutti gli stati' });
  const [userSearch, setUserSearch] = useState('');
  const [alloggiBackup, setAlloggiBackup] = useState([]);
  const [csvDateFrom, setCsvDateFrom] = useState('');
  const [csvDateTo, setCsvDateTo] = useState('');

  // Modal state
  const [show, setShow] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [showAddPrenotazione, setShowAddPrenotazione] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  // Prenotazione data
  const [data_prenotata, setDataPrenotata] = useState();
  const [id_prenotazione_, setIdPrenotazione_] = useState(0);
  const [giorno, setGiorno] = useState("");
  const [users_all, setAllUsers] = useState([]);
  const [id_cammino, setIdcammino] = useState(0);
  const [strutture, setStrutture] = useState([]);
  const [tappe_all, setTappeAll] = useState([]);
  const [stato_prenotazione, setStatoPrenotazione] = useState("In Attesa");
  const [newGiorno, setNewGiorno] = useState({});
  const [bagagli, setBagagli] = useState(0);
  const [totale, setTotale] = useState(0);
  const [loader, setLoader] = useState(false);
  const [prenotazioni, setPrenotazioni] = useState([]);
  const [id_alloggio_inizio, setIdAlloggioInizio] = useState(0);
  const [id_alloggio_fine, setIdAlloggioFine] = useState(0);
  const [id_utente, setIdUtente] = useState(0);
  const [nome_tappa_inizio, setNomeTappaInizio] = useState("");
  const [nome_tappa_fine, setNomeTappaFine] = useState("");
  const [tracking_link_pickup, setTrackingLinkPickup] = useState("");
  const [tracking_link_delivery, setTrackingLinkDelivery] = useState("");

  // Search function
  const search = (keyword) =>
    setAlloggi(
      alloggiBackup.filter((el) =>
        el.stato_prenotazione.toUpperCase().includes(keyword.toUpperCase())
      )
    );

  /* Handle functions */
  const handleShowUpdate = () => setShowUpdate(true);
  const handleShow = () => setShow(true);

  const handleClosePrenotazione = () => {
    setShowAddPrenotazione(false);
    setModalError(false);
  };

  const updateConfermaStatus = async () => {
    await getAlloggiByStatus(token);
  };

  const handleCloseUpdate = async () => {
    setShowUpdate(false);
    setOpen();
    setPrenotazioni([]);
    await updateConfermaStatus();
  };

  const handleShowInfo = () => setShowInfo(true);

  const handleCloseInfo = async () => {
    setShowInfo(false);
    setOpen();
    setPrenotazioni([]);
    await updateConfermaStatus();
  };

  const handleClose = async () => {
    setShow(false);
    setModalError(false);
    await updateConfermaStatus();
  };

  // Fetch prenotazioni
  const fetchAllPrentazioni = async () => {
    const totalPrenotazioni = await getPrenotazioniAll(token, page, {
      status: status.value,
      user_search: userSearch
    });
    setPrenotazioniAll(totalPrenotazioni);
  }

  // Initial data load
  const start = async () => {
    setLoader(true);
    const result = await getAlloggi(token);
    setAlloggi(result);
    setAlloggiBackup(result);
    setLoader(false);
    await updateConfermaStatus();
    setInterval(async () => {
      const result = await getAlloggi(token);
      setAlloggi(result);
      setAlloggiBackup(result);
      await updateConfermaStatus();
    }, 500000);
  };

  // Set up effects
  useEffect(() => {
    start();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [userSearch, status]);

  useEffect(() => {
    fetchAllPrentazioni();
  }, [page, status, userSearch]);

  // Function to add new prenotazione
  const handleAddPrenotazione = async () => {
    let users_all = await getAllUtenti(token);
    await setAllUsers(users_all);
    handleShow();
  };

  // Function to download CSV
  const handleDownloadCSV = async () => {
    try {
      setLoader(true);
      const filters = {};
      if (csvDateFrom) filters.date_from = csvDateFrom;
      if (csvDateTo) filters.date_to = csvDateTo;
      const result = await downloadServiziCSV(token, filters);
      if (result.success) {
        // Download completato con successo
        console.log('CSV scaricato con successo');
      } else {
        // Errore nel download
        console.error('Errore nel download del CSV:', result.error);
        setModalError(true);
      }
    } catch (error) {
      console.error('Errore durante il download:', error);
      setModalError(true);
    } finally {
      setLoader(false);
    }
  };

  // Function to prepare update prenotazione
  const prepareUpdatePrenotazione = async (tappa, cammino) => {
    await setTappeAll(await getTappeAll(token));
    await setStrutture(await getStrutture(token));
    setNewGiorno({
      id_prenotazione: cammino.id,
      id_tappa_prenotazione: tappa.id,
      tappa_inizio: tappa.id_tappa_inizio,
      tappa_fine: tappa.id_tappa_fine,
      costo: tappa.costo_prenotazione_singola,
      data: tappa.data_prenotazione,
      alloggio_ritiro: tappa.id_alloggio_inizio,
      alloggio_consegna: tappa.id_alloggio_fine,
      bagagli: tappa.quantita_bagagli,
      nome_tappa_inizio: tappa.nome_tappa_inizio,
      nome_tappa_fine: tappa.nome_tappa_fine,
      stato_prenotazione: tappa.stato,
    });
    handleShowUpdate();
  };

  // Function to prepare info prenotazione
  const prepareInfoPrenotazione = async (tappa, index) => {
    let giorno = `Giorno ${index + 1}`;
    await setGiorno(giorno);
    await setIdcammino(tappa.id);
    await setBagagli(tappa.quantita_bagagli);
    await setNomeTappaInizio(tappa.nome_tappa_inizio);
    await setNomeTappaFine(tappa.nome_tappa_fine);
    await setDataPrenotata(tappa.data_prenotazione);
    await setIdAlloggioInizio({
      nome: tappa.alloggio_inizio_nome,
      attivo: tappa.alloggio_inizio_attivo
    });
    await setIdAlloggioFine({
      nome: tappa.alloggio_fine_nome,
      attivo: tappa.alloggio_fine_attivo
    });
    await setStatoPrenotazione(
      mapStatus[tappa.stato].name
    );
    await setTrackingLinkPickup(tappa.tracking_link_pickup || "");
    await setTrackingLinkDelivery(tappa.tracking_link_delivery || "");
    handleShowInfo();
  };

  // Function to prepare add giorno
  const prepareAddGiorno = async (camminoId, idUtente) => {
    await setStrutture(await getStrutture(token));
    await setTappeAll(await getTappeAll(token));
    await setIdPrenotazione_(camminoId);
    // Serve per far riconoscere all'offcanvas se l'utente è agenzia (isAgency)
    // e applicare la logica prezzo B2B corretta.
    if (idUtente) {
      await setIdUtente(idUtente);
      if (users_all.length === 0) {
        const fetched = await getAllUtenti(token);
        await setAllUsers(fetched);
      }
    }
    await setShowAddPrenotazione(true);
  };

  return (
    <div style={{ width: "100%" }}>
      <ModalError modalError={modalError} setModalError={setModalError} />
      <ModalSuccess modalSuccess={modalSuccess} setModalSuccess={setModalSuccess} />

      <ModalDeletePrenotazione
        deletecammino={deletecammino}
        showDelete={showDelete}
        setShowDelete={setShowDelete}
        handleCloseInfo={handleCloseInfo}
        id_cammino={id_cammino}
        token={token}
        getAlloggi={getAlloggi}
        setAlloggi={setAlloggi}
        setOpen={setOpen}
      />

      {/* Offcanvas components */}
      <PrenotazioneUpdateOffcanvas
        showUpdate={showUpdate}
        handleCloseUpdate={handleCloseUpdate}
        newGiorno={newGiorno}
        setNewGiorno={setNewGiorno}
        nome_tappa_inizio={nome_tappa_inizio}
        nome_tappa_fine={nome_tappa_fine}
        tappe_all={tappe_all}
        strutture={strutture}
        token={token}
        updatecammino={updatecammino}
        getAlloggi={getAlloggi}
        setAlloggi={setAlloggi}
        setAlloggiBackup={setAlloggiBackup}
        setModalError={setModalError}
        setModalSuccess={setModalSuccess}
        id_cammino={id_cammino}
        id_prenotazione_={id_prenotazione_}
        refreshPrenotazioni={fetchAllPrentazioni}
      />

      <PrenotazioneAddOffcanvas
        show={show}
        handleClose={handleClose}
        users_all={users_all}
        setIdUtente={setIdUtente}
        id_utente={id_utente}
        stato_prenotazione={stato_prenotazione}
        token={token}
        insertcammino={insertcammino}
        setModalError={setModalError}
        setModalSuccess={setModalSuccess}
        getAlloggi={getAlloggi}
        setAlloggi={setAlloggi}
        setAlloggiBackup={setAlloggiBackup}
        refreshPrenotazioni={fetchAllPrentazioni}
      />

      <PrenotazioneAddGiornoOffcanvas
        showAddPrenotazione={showAddPrenotazione}
        handleClosePrenotazione={handleClosePrenotazione}
        setNewGiorno={setNewGiorno}
        newGiorno={newGiorno}
        tappe_all={tappe_all}
        strutture={strutture}
        id_prenotazione_={id_prenotazione_}
        id_utente={id_utente}
        users_all={users_all}
        token={token}
        insertcammino2={insertcammino2}
        setModalError={setModalError}
      />

      <PrenotazioneInfoOffcanvas
        showInfo={showInfo}
        handleCloseInfo={handleCloseInfo}
        setShowInfo={setShowInfo}
        setShowUpdate={setShowUpdate}
        giorno={giorno}
        nome_tappa_inizio={nome_tappa_inizio}
        nome_tappa_fine={nome_tappa_fine}
        id_cammino={id_cammino}
        id_utente={id_utente}
        data_prenotata={data_prenotata}
        totale={totale}
        stato_prenotazione={stato_prenotazione}
        bagagli={bagagli}
        id_alloggio_inizio={id_alloggio_inizio}
        id_alloggio_fine={id_alloggio_fine}
        tracking_link_pickup={tracking_link_pickup}
        tracking_link_delivery={tracking_link_delivery}
      />

      {/* Header */}
      <div
        style={{
          paddingTop: "20px",
          width: "100%",
          backgroundColor: "#F4F4F4",
        }}
      >
        <h1 className="title-sezione">
          <img
            src="prenotazioniIcon.svg"
            style={{
              position: "relative",
              bottom: "3px",
              width: "23px",
              marginRight: "12px",
            }}
            alt=""
          />
          Prenotazioni
        </h1>
        <div style={{ marginTop: "30px", width: "100%" }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "20px"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              flex: 1
            }}>
              <SearchForm
                nome="Cerca per utente..."
                search={(keyword) => setUserSearch(keyword)}
                style={{ flex: "1" }}
              />
              <div style={{ width: "200px" }}>
                <StatusSelect status={status} setStatus={setStatus} />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", backgroundColor: "white", borderRadius: "25px", boxShadow: "0px 3px 6px #00000029", padding: "0 12px", height: "50px" }}>
              <span style={{ fontSize: "0.8em", color: "#666", whiteSpace: "nowrap" }}>Data servizio:</span>
              <input
                type="date"
                value={csvDateFrom}
                onChange={(e) => setCsvDateFrom(e.target.value)}
                style={{ border: "none", outline: "none", fontSize: "0.85em", color: "#333", width: "130px" }}
                title="Da"
              />
              <span style={{ color: "#ccc" }}>–</span>
              <input
                type="date"
                value={csvDateTo}
                onChange={(e) => setCsvDateTo(e.target.value)}
                style={{ border: "none", outline: "none", fontSize: "0.85em", color: "#333", width: "130px" }}
                title="A"
              />
              <button
                onClick={handleDownloadCSV}
                style={{ background: "none", border: "none", cursor: "pointer", padding: "0 4px", display: "flex", alignItems: "center", color: "#333" }}
                title="Scarica CSV dei servizi"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 11L3 6h3V1h4v5h3l-5 5zM1 13h14v2H1v-2z" fill="currentColor" />
                </svg>
              </button>
            </div>
            <button
              variant="primary"
              onClick={handleAddPrenotazione}
              className="btn btn-default btn-rounded"
              data-toggle="modal"
              data-target="#modalRegisterForm"
              style={{
                border: "none",
                boxShadow: "0px 3px 6px #00000029",
                borderRadius: "25px",
                height: "50px",
                padding: "0 20px",
                fontSize: "0.9em",
                backgroundColor: "white",
                minWidth: "200px"
              }}
            >
              Aggiungi Prenotazione
            </button>
          </div>
        </div>
      </div>

      {/* Main content - Prenotazioni table */}
      <PrenotazioniTable
        prenotazioniAll={prenotazioniAll}
        open={open}
        setOpen={setOpen}
        loader={loader}
        prepareUpdatePrenotazione={prepareUpdatePrenotazione}
        prepareInfoPrenotazione={prepareInfoPrenotazione}
        prepareAddGiorno={prepareAddGiorno}
        getTappeAll={getTappeAll}
        getStrutture={getStrutture}
        token={token}
      />

      {/* Pagination */}
      <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <Pagination page={page} setPage={setPage} pagination={prenotazioniAll?.pagination} />
      </div>
    </div>
  );
};

export default Tappe;